import axios from "../../utils/axios";

export const getRelatedBlogs = async ({id, tags}) => {
    const limit = 5;
    const queryString =
      tags?.length > 0
        ? tags.map((tag) => `tags_like=${tag}`).join("&") +
          `&id_ne=${id}&limit=${limit}`
        : `&id_ne=${id}&limit=${limit}`;
  
    const responce = await axios.get(`/blogs?${queryString}`);
    return responce.data;
  };